import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import { getPageContext, navigationSections } from "../utils/navigation";

export default function AppBreadcrumbs() {
  const { pathname } = useLocation();
  const { state } = useApp();
  const context = getPageContext(pathname, state.auth.user?.role);
  const detail =
    pathname.startsWith("/machines/") && pathname !== "/machines/manage";
  const machine = detail
    ? state.machines.find((m) => m.id === pathname.split("/")[2])
    : undefined;
  const section = navigationSections.find(
    (s) => s.id === context?.section,
  )?.label;
  return (
    <Breadcrumbs
      aria-label="Percorso di navigazione"
      separator={<ChevronRight sx={{ fontSize: 15, color: "text.disabled" }} />}
      sx={{
        "& .MuiBreadcrumbs-ol": { flexWrap: "nowrap" },
        "& .MuiBreadcrumbs-li": { minWidth: 0 },
        "& .MuiBreadcrumbs-separator": { mx: 0.75 },
      }}
    >
      {pathname !== "/dashboard" && (
        <Link
          component={RouterLink}
          to="/dashboard"
          underline="hover"
          color="text.secondary"
          sx={{
            display: { xs: "none", sm: "inline" },
            fontSize: 12,
            whiteSpace: "nowrap",
          }}
        >
          Workspace
        </Link>
      )}
      {detail ? (
        <Link
          component={RouterLink}
          to="/machines"
          underline="hover"
          color="text.secondary"
          sx={{ fontSize: 12, whiteSpace: "nowrap" }}
        >
          Macchine
        </Link>
      ) : section && pathname !== "/dashboard" ? (
        <Typography
          sx={{
            display: { xs: "none", lg: "block" },
            fontSize: 12,
            color: "text.secondary",
            whiteSpace: "nowrap",
          }}
        >
          {section}
        </Typography>
      ) : null}
      <Typography
        aria-current="page"
        noWrap
        sx={{
          fontSize: 12,
          fontWeight: 700,
          color: "text.primary",
          maxWidth: { xs: 130, md: 230 },
        }}
      >
        {machine?.name || context?.label || "Pagina"}
      </Typography>
    </Breadcrumbs>
  );
}
